<template>
  <v-container>
    <h2 class="text-center my-12">{{ $t("palworld.title") }}</h2>
    <v-card class="mx-auto my-8" elevation="4" max-width="900">
      <v-img :src="palworldHeader" cover></v-img>

      <v-container>
        <v-form ref="form">
          <p class="text-label-large">{{ $t("palworld.inquiry_type") }}<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
          <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputType" :items="[
            { title: $t('palworld.type.bug'), value: 'bug' },
            { title: $t('palworld.type.feedback'), value: 'feedback' },
            { title: $t('palworld.type.officialserver'), value: 'officialserver' },
            { title: $t('palworld.type.others'), value: 'others' },
          ]"></v-select>
          <template v-if="inputType">
            <template v-if="inputType === 'bug'">
              <p class="text-label-large">{{ $t("palworld.situation") }}<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
              <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputBugSituation"
                :items="[
                  { title: $t('palworld.bug_situation.cannot_boot'), value: 'cannot_boot_the_game' },
                  { title: $t('palworld.bug_situation.crash'), value: 'crash_the_game' },
                  { title: $t('palworld.bug_situation.cannot_load_world'), value: 'cannot_load_world' },
                  { title: $t('palworld.bug_situation.others'), value: 'others' },
                ]"></v-select>
            </template>
            <template v-if="inputType === 'officialserver'">
              <p class="text-label-large">{{ $t("palworld.situation") }}<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
              <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputOfficialServerProblemSituation"
                :items="[
                  { title: $t('palworld.server_situation.server_down'), value: 'server_down' },
                  { title: $t('palworld.server_situation.frequent_disconnect'), value: 'frequent_disconnect' },
                  { title: $t('palworld.server_situation.cheating'), value: 'cheating' },
                  { title: $t('palworld.server_situation.harassment'), value: 'harassment' },
                  { title: $t('palworld.server_situation.others'), value: 'others' },
                ]"></v-select>
              <p class="text-label-large">{{ $t("palworld.target_server_region") }}<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
              <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputOfficialServerTargetServer"
                :items="[
                  { title: 'NA (North America)', value: 'na' },
                  { title: 'SA (South America)', value: 'sa' },
                  { title: 'China', value: 'cn' },
                  { title: 'Asia', value: 'as' },
                  { title: 'JP (Japan)', value: 'jp' },
                  { title: 'EU (Europe)', value: 'eu' },
                  { title: $t('palworld.server_region.all'), value: 'all' },
                ]"></v-select>
              <p class="text-label-large">{{ $t("palworld.target_user") }}<span class="text-red ml-2"></span></p>
              <v-text-field :placeholder="$t('app.input_placeholder')" v-model="inputTargetUserId"></v-text-field>
            </template>


            <template v-if="inputType === 'others'">
              <p class="text-label-large">{{ $t("palworld.summary") }}<span class="text-red ml-2">※{{ $t("app.required") }}</span></p>
              <v-text-field :placeholder="$t('app.input_placeholder')" :rules="[requiredValidation]" v-model="inputTitle"></v-text-field>
            </template>

            <p class="text-label-large">{{ $t("palworld.details") }}<span class="text-red ml-2">※{{
              $t("app.required")
                }}</span></p>
            <v-textarea :placeholder="$t('app.input_placeholder')" :rules="[requiredValidation]" v-model="inputDetails"></v-textarea>
            <template v-if="inputType !== 'others'">
              <p class="text-label-large">{{ $t("palworld.screenshots") }}</p>
              <p class="text-label-medium" v-if="inputType === 'officialserver'">{{ $t("palworld.screenshots_evidence") }}</p>
              <v-file-input :label="$t('palworld.screenshots_label')" :prepend-icon="mdiImage" counter multiple show-size
                accept="image/*, video/*" :rules="[fileInputValidation]" v-model="inputFiles"></v-file-input>
            </template>
            <template v-if="inputType !== 'others'">
              <p class="text-label-large">{{ $t("palworld.platform") }}<span class="text-red ml-2">※{{ $t("app.required")
                  }}</span>
              </p>
              <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputPlatform"
                :items="platformItems"></v-select>
            </template>
            <template v-if="inputType === 'bug' || inputType === 'officialserver'">
              <p class="text-label-large">{{ $t("palworld.mod_usage") }}<span class="text-red ml-2">※{{ $t("app.required")
                  }}</span>
              </p>
              <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputModUsage"
                :items="[
                  { title: $t('palworld.mod.currently_using'), value: 'currently_using' },
                  { title: $t('palworld.mod.previously_used'), value: 'previously_used' },
                  { title: $t('palworld.mod.never_used'), value: 'never_used' },
                ]"></v-select>
            </template>
            <template v-if="inputType === 'bug'">
              <p class="text-label-large">{{ $t("palworld.play_mode") }}<span class="text-red ml-2">※{{ $t("app.required")
                  }}</span>
              </p>
              <v-select :placeholder="$t('app.select_placeholder')" max-width="500" :rules="[requiredValidation]" v-model="inputPlaymode"
                :items="[
                  { title: $t('palworld.playmode.singleplayer'), value: 'singleplayer' },
                  { title: $t('palworld.playmode.coop'), value: 'coop' },
                  { title: $t('palworld.playmode.dedicated_server'), value: 'dedicated_server' },
                ]"></v-select>
            </template>
            <template v-if="inputType === 'bug' || inputType === 'officialserver'">
              <p class="text-label-large">{{ $t("palworld.game_version") }}</p>
              <v-text-field :placeholder="$t('app.input_placeholder')" v-model="inputVersion"></v-text-field>
            </template>

            <p class="text-label-large">{{ $t("palworld.contact") }}</p>
            <v-row>
              <v-col cols="12" sm="4">
                <v-select :placeholder="$t('app.select_placeholder')" v-model="inputContactType" :items="[
                  { title: 'Discord', value: 'Discord' },
                  { title: 'X(Twitter)', value: 'Twitter' },
                  { title: 'E-mail', value: 'Email' },
                ]"></v-select>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field :placeholder="$t('app.input_placeholder')" v-model="inputContact"></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-form>
        <v-progress-linear indeterminate color="cyan" v-if="isSubmitting"></v-progress-linear>
        <v-btn elevated color="cyan" class="mt-4 ml-auto d-block" :loading="isSubmitting" @click="submitForm">
          {{ $t("app.submit") }}
        </v-btn>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import palworldHeader from '@/assets/img/header_palworld.jpg'

const PALWORLD_LAST_SUBMITTED_AT_COOKIE = 'palworld_last_submitted_at'
const PALWORLD_LAST_SUBMITTED_AT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export default {
  name: 'PalworldView',
  computed: {
    platformItems() {
      const items = [
        { title: 'Steam', value: 'steam' },
        { title: 'Microsoft Store', value: 'mswin' },
        { title: 'Xbox One', value: 'xbox_one' },
        { title: 'Xbox Series X/S', value: 'xbox_series' },
        { title: 'PS5', value: 'ps5' },
        { title: 'MacOS', value: 'mac' },
      ]

      if (this.inputType === 'feedback') {
        items.push({ title: this.$t('palworld.platform_all'), value: 'all' })
      }

      return items
    },
  },
  data() {
    return {
      palworldHeader,
      inputType: null,
      inputBugSituation: null,
      inputOfficialServerProblemSituation: null,
      inputOfficialServerTargetServer: null,
      inputTitle: null,
      inputDetails: null,
      inputFiles: [],
      inputPlatform: null,
      inputModUsage: null,
      inputPlaymode: null,
      inputVersion: null,
      inputContactType: null,
      inputContact: null,
      qpamSessionId: null,
      qpamReportUserId: null,
      qpamOpenFrom: null,
      qpamPlatformMetadata: null,
      inputTargetUserId: null,
      isSubmitting: false,
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    this.inputVersion = params.get('version') || null
    this.qpamSessionId = params.get('session_id') || null
    this.qpamReportUserId = params.get('user_id') || null
    this.qpamOpenFrom = params.get('from') || null
    this.qpamPlatformMetadata = params.get('platform_metadata') || null
    this.inputTargetUserId = params.get('report_user_id') || null
  },
  methods: {
    requiredValidation(value) {
      return !!value || this.$t('app.required_message')
    },
    fileInputValidation(value) {
      if (!value || value.length === 0) return true
      const invalidFile = value.find((file) => !file.type.startsWith('image/') && !file.type.startsWith('video/'))
      if (invalidFile) return this.$t('app.invalid_file_type', { name: invalidFile.name })
      if (value.length > 3) return this.$t('app.max_files_exceeded')
      const totalSize = value.reduce((acc, file) => acc + file.size, 0)
      if (totalSize > 30 * 1024 * 1024) return this.$t('app.max_size_exceeded')
      return true
    },
    getCookieValue(name) {
      const cookies = document.cookie ? document.cookie.split('; ') : []
      const cookie = cookies.find((row) => row.startsWith(`${name}=`))
      return cookie ? decodeURIComponent(cookie.substring(name.length + 1)) : ''
    },
    setCookieValue(name, value) {
      document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${PALWORLD_LAST_SUBMITTED_AT_COOKIE_MAX_AGE}; path=/; SameSite=Lax`
    },
    async submitForm() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      this.isSubmitting = true

      const lastSubmittedAt = this.getCookieValue(PALWORLD_LAST_SUBMITTED_AT_COOKIE)

      const formData = new FormData()
      formData.append('type', this.inputType || '')
      formData.append('bug_situation', this.inputBugSituation || '')
      formData.append('official_server_problem_situation', this.inputOfficialServerProblemSituation || '')
      formData.append('official_server_target_server', this.inputOfficialServerTargetServer || '')
      formData.append('title', this.inputTitle || '')
      formData.append('description', this.inputDetails || '')
      formData.append('platform', this.inputPlatform || '')
      formData.append('mod_usage', this.inputModUsage || '')
      formData.append('mode', this.inputPlaymode || '')
      formData.append('version', this.inputVersion || '')
      formData.append('contact', (this.inputContactType ? this.inputContactType + ': ' : '') + (this.inputContact || ''))
      formData.append('target_user_id', this.inputTargetUserId || '')
      formData.append('session_id', this.qpamSessionId || '')
      formData.append('user_id', this.qpamReportUserId || '')
      formData.append('open_from', this.qpamOpenFrom || '')
      formData.append('platform_metadata', this.qpamPlatformMetadata || '')
      formData.append('last_submitted_at', lastSubmittedAt)

      if (this.inputFiles) {
        this.inputFiles.forEach((file) => {
          formData.append('screenshots', file)
        })
      }

      fetch('https://pocketpair-forms-api-dot-pocketpair.an.r.appspot.com/v1/api/form/palworld-renewed', {
        method: 'POST',
        body: formData,
      }).then((res) => {
        if (res.status === 200) {
          this.setCookieValue(PALWORLD_LAST_SUBMITTED_AT_COOKIE, new Date().toISOString())
          this.$router.push('/submitted')
        } else {
          console.log(res.status)
        }
      }).catch((err) => {
        console.error(err)
      }).finally(() => {
        this.isSubmitting = false
      })
    }
  }
}
</script>